import React from 'react';

export default props => {
    return (
        <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 0.5L9 8.5M17 16.5L9 8.5M9 8.5L17 0.5M9 8.5L1 16.5" stroke="#BDBDBD"/>
        </svg>
    );
};
